export default __webpack_public_path__ + "static/media/Poster3.2e92bfa2.jpg";